<template>
  <div>
    <div class="modal fade" :id="oig_id !== '' ? 'm' + oig_id : 'm' + value.oig_id" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title">{{ value.group_name }}</div>
            <div v-if="this.selectname == 0" class="price"><b>$0</b></div>
            <div v-else class="price"><b>${{ price | formatNumberToqff }}</b></div>
            <!-- <label class="num">数量</label> -->
            <div class="select d-flex justify-content-between align-items-center">
              <div class="title">商品規格</div>
              <div class="prom_bar">
                <label class="tags white_space mb-0">規格</label>
                <div class="txt">共 2 種規格可選</div>
                <span class="more_btn"><i class="icon-keyboard_arrow_right"></i></span>
              </div>
              <!-- data-bs-toggle="modal" data-bs-target="#exampleModal2" -->
              <div class="form_label pb-0" for="">
                選擇規格</div>
              <select name="" id="" @change="clickvalue(value.oig_id)" v-model="selectname">
                <option value="0" checked="" disabled>請選擇</option>
                <option v-for="itemes in item.items" :value="itemes.itemid" :label="itemes.name">{{ itemes.name }}
                </option>
              </select>
            </div>
            <div class="selectquantity d-flex justify-content-between align-items-center">
              <div class="form_label pb-0" for="">數量</div>
              <div class="selectquantity_select">
                <div class=" number d-flex   justify-content-between ">
                  <button type="button" class="btn iconfont" @click="reduce()">&#xeaf5;
                  </button>
                  <input @change="numberchange(number)" type="text" name="quantity" v-model="number"
                    class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                  <button type="button" class="btn iconfont" @click="add()">&#xeaf3;
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-btn d-flex">
              <div class="add modalgo" data-bs-dismiss="" aria-label="" @click="addcart()">加入購物車</div>
              <div class="buy modalgo" data-bs-dismiss="" aria-label="" @click="gocart()">立即購買</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 模态框 -->
    <div class="modal fade child" :id="oig_id !== '' ? 'c' + oig_id : 'c' + value.oig_id" tabindex="-1" aria-labelledby="exampleModalLabel2"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel"> {{ content_name }} </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- {{ child_list }} -->
            <h2 class="title">请选择{{ child_num }}件商品 </h2>
            <div v-for="item, index in child_list">
              <div class="form_name"> *{{ item.form_name }}</div>
              <div class="number">
                <button type="button" class="btn iconfont" @click="decrement(index)">-
                </button>
                <input type="number" name="quantity" @input="validateInput(index)" v-model="item.display_num"
                  class=" text-center w-100   p-0" data-max="1" data-min="1">
                <button type="button" class="btn iconfont" @click="increment(index)">+
                </button>
              </div>
            </div>
            <!-- <div>
              请选择{{ free_num }}件赠品：
            </div>
            <div v-for="item, index in free">
              <div class="form_name"> *{{ item.form_name }}</div>
              <div class="number">
                <button type="button" class="btn iconfont" @click="decrement_free(index)">-
                </button>
                <input type="number" name="quantity" @input="validateInput_free(index)" v-model="item.display_num"
                  class=" text-center w-100   p-0" data-max="1" data-min="1">
                <button type="button" class="btn iconfont" @click="increment_free(index)">+
                </button>
              </div>
            </div> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
            <button type="button" class="btn btn-primary" @click="opmodef">確認</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import FacebookEventApi from '@/js/FacebookEventApi'
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import { mapState } from 'vuex'
import numeral from "numeral";
import $ from 'jquery'
export default {
  components: {},
  props: {
    value: {
      default: ''
    },
    oig_id: {
      default: ''
    }
  },
  filters: {
    formatNumberToqff(val) {
      return numeral(val).format('0,0');
    }
  },
  data() {
    return {
      selectname: '0',
      saveselectname: '0',
      item: {},
      firstprice: 0,
      number: 1,
      price: 0,
      shop_name: '',

      // addtocart2
      content_name: '',//商品名字
      content_ids: '',//id
      values: '',//价格
      contents_quantity: '',//数量
      F_oig_id: '',//父商品的id

      //child
      child_list: [],//子商品内容
      child_num: '',//子商品默认数量
      child_number: '',//记录商品数量总和
      parm: [],//修改后的子商品各个的数量
      //赠品
      free: [],//赠品
      free_num: '',//赠品数量
      free_number: '',//记录赠品数量总和
      free_parm: [],//修改后的赠品各个的数量

    };
  },
  computed: {
    ...mapState('header', ['cate', 'website', 'getnav', 'getfb']),
    ...mapState('cart', ['cart_list_item']),
    totalSum() {
      return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
    },
    totalSum_free() {
      return this.free.reduce((sum, item) => sum + item.display_num, 0);
    }
  },
  watch: {},
  methods: {
    opmodef(val) {
      // this.item=this.$store.getters["commodity/details"];
      // this.clickvalue();
      let number = 0
      this.parm = this.child_list.map(item => {
        number += item.display_num
        return {
          item: item.isubid,
          num: item.display_num
        };
      });
      // let number_free = 0
      this.free_parm = this.free.map(item => {
        // number_free += item.display_num
        return {
          item: item.isubid,
          num: this.free_num * this.number
        };
      });
      if (number == this.child_num) {
        console.log('确认');
        this.selectname = this.saveselectname;
        // const myModal2 = new this.$bootstrap.Modal(document.getElementById('m' + this.F_oig_id));
        // const myModal = this.$bootstrap.Modal.getInstance(document.getElementById('c' + this.F_oig_id));
        // myModal.hide();
        if (this.oig_id !== '') {
                  const myModal2 = new this.$bootstrap.Modal(document.getElementById('m' + this.oig_id));
                  const myModal =  this.$bootstrap.Modal.getInstance(document.getElementById('c' + this.oig_id));
                  myModal.hide();
                  myModal2.show();
                } else {
                  const myModal2 = new this.$bootstrap.Modal(document.getElementById('m' + this.F_oig_id));
                  const myModal =  this.$bootstrap.Modal.getInstance(document.getElementById('c' + this.F_oig_id));
                  myModal.hide();
                  myModal2.show();

                }
        // myModal2.show();
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 1500,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`
        })
      }
    },
    clickvalue(e) {
      this.F_oig_id = e;
      // console.log(this.F_oig_id);
      this.parm = [];
      // console.log(e);
      this.item.items.forEach(element => {
        if (element.itemid === this.selectname) {
          this.$store.dispatch('commodity/getsubcategory', this.selectname).then(response => {
            if (response.result) {
              this.child_list = response.data.sub || [];
              this.child_num = response.data.num || 0;
              this.free = response.data.sub_free || [];
              this.free_num = response.data.num_free || 0;
              if (response.data.sub?.length === 1) {
                this.child_list[0].display_num = response.data.num
                switch (response.data.sub_free.length) {
                  case 0:
                    this.parm = [
                      {
                        item: response.data.sub[0].isubid,
                        num: response.data.num
                      }
                    ]
                    break;
                  default:
                    this.free_parm = this.free.map(item => {
                      // number_free += item.display_num
                      return {
                        item: item.isubid,
                        num: this.free_num * this.number
                      };
                    });
                    this.parm = [
                      {
                        item: response.data.sub[0].isubid,
                        num: response.data.num
                      }
                    ]
                    break;
                }
              } else if (response.data.sub?.length > 0) {
                if (this.oig_id !== '') {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.oig_id));
                  const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.oig_id));
                  myModal2.hide();
                  myModal.show();
                } else {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.F_oig_id));
                  const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.F_oig_id));
                  myModal2.hide();
                  myModal.show();

                }
                // const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.F_oig_id));
                // myModal2.hide();
                // myModal.show();
                this.saveselectname = this.selectname;
              } else if (response.data.sub?.length === 0) {

                switch (response.data.sub_free.length) {
                  case 0:
                    this.parm = [
                    ]
                    break;
                  default:
                    this.free_parm = this.free.map(item => {
                      // number_free += item.display_num
                      return {
                        item: item.isubid,
                        num: this.free_num * this.number
                      };
                    });
                    this.parm = [
                    ]
                    break;
                }
              }
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'error',
                title: `${response.message}`
              })
            }
            // $('#myModal').modal('show');
            // console.log($('#myModal'));
            // console.log($('#myModal').modal());
          });
          this.content_name = element.name;
          this.content_ids = element.itemid;
          this.values = element.price;
          this.number = 1;
          // console.log(this.content_name);
        }
      })
      if (this.selectname != 0) {
        for (let index = 0; index < $('.modalgo').length; index++) {
          $('.modalgo')[index].ariaLabel = 'Close';
          $('.modalgo')[index].dataset.bsDismiss = 'modal';
        }
      } else {
        for (let index = 0; index < $('.modalgo').length; index++) {
          $('.modalgo')[index].ariaLabel = null;
          $('.modalgo')[index].dataset.bsDismiss = null;

        }
      }
      this.item.items.forEach(element => {
        if (element.itemid === this.selectname) {
          this.firstprice = element.price;
          this.price = element.price * this.number;
          return
        } else {
        }
      })
    },
    numberchange(e) {
      this.price = this.firstprice * this.number

    },
    // 数量减
    reduce() {
      if (this.number > 1) {
        this.number--;
        this.price = this.firstprice * this.number
      }
    },
    // 数量加
    add() {
      if (this.number < 99) {
        this.number++;
        this.price = this.firstprice * this.number
      }
    },
    getitem() {
      console.log(this.value.oig_id);
      this.$store.dispatch('commodity/getdesignated_product', this.value.oig_id).then(response => {
        this.item = this.$store.getters["commodity/details"];
        if (this.item.items.length == 1) {
          console.log(this.selectname);
          this.selectname = this.item.items[0].itemid;
          this.firstprice = this.item.items[0].price;
          this.price = this.item.items[0].price;
          this.content_name = this.item.items[0].name;
          this.content_ids = this.item.items[0].itemid;
          this.values = this.item.items[0].price;
          this.number = 1;
          console.log(this.selectname);
          this.clickvalue(this.item.oig_id);
        }

      })
    },
    addcart() {
      if (this.selectname == 0) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 1500,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'error',
          title: '請選擇規格'
        })
      } else {
        var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash, this.getfb.ShenV1FbPixel1_domain);
        var fb_em = myFacebookEventApi.fbgetCookie('em');
        var fb_phone = myFacebookEventApi.fbgetCookie('phone');
        var fb_fn = myFacebookEventApi.fbgetCookie('fn');
        var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
        var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
        myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.number, this.price, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
        if (this.parm.length !== 0) {
          this.parm.forEach(element => {
            element.num = element.num * this.number;
          });
        }
        if (this.free_parm.length !== 0) {
          this.free_parm.forEach(element => {
            element.num = element.num * this.number;
          });
        }
        // this.free_parm=[
        //   {
        //     item:'142',
        //     num:30
        //   },
        //   {
        //     item:'143',
        //     num:30
        //   }
        // ]
        this.child_number = this.number
        if (this.cart_list_item.length !== 0) {
          this.cart_list_item.forEach(element => {
            if (this.selectname == element.item_id) {
              this.child_number += element.num
              element.sub.forEach(sub_item => {
                const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                if (existingItem) {
                  // 如果存在，则将数量相加
                  existingItem.num += sub_item.num;
                }

                const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                if (free_existingItem) {
                  // 如果存在，则将数量相加
                  free_existingItem.num += sub_item.num;
                }

              });
            }
          });
        }
        this.parm = this.parm.concat(this.free_parm);
        this.free_parm = [];
        // console.log(this.parm,'add接口前传参');
        this.$store.dispatch('cart/add', {
          action: 'UPDATE',
          itemid: this.selectname,
          number: this.child_number,
          type: 'NOR',
          param: this.parm,
        }).then((e) => {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          if (e.result) {
            Toast.fire({
              icon: 'success',
              title: '成功加入購物車'
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: `${e.message}`
            })
          }
        });
        if (this.oig_id !== '') {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.oig_id));
                  myModal2.hide();
                } else {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.F_oig_id));
                  myModal2.hide();

                }
        // const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.F_oig_id));
        // myModal2.hide();
        // console.log(this.parm);
        // 選擇頁面上所有的.modal-backdrop元素
        const elements = document.querySelectorAll('.modal-backdrop');
        // 遍歷這些元素並移除
        elements.forEach(el => el.parentNode.removeChild(el));
      }
    },
    gocart() {
      if (this.selectname == 0) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 1500,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'error',
          title: '請選擇規格'
        })
      } else {
        var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash, this.getfb.ShenV1FbPixel1_domain);
        var fb_em = myFacebookEventApi.fbgetCookie('em');
        var fb_phone = myFacebookEventApi.fbgetCookie('phone');
        var fb_fn = myFacebookEventApi.fbgetCookie('fn');
        var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
        var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
        myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.number, this.price, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
        if (this.parm.length !== 0) {

          this.parm = this.child_list.map(item => {
            return {
              item: item.isubid,
              num: item.display_num
            };
          });
          this.parm.forEach(element => {
            element.num = element.num * this.number;
          });
        }
        if (this.free_parm.length !== 0) {
          this.free_parm.forEach(element => {
            element.num = element.num * this.number;
          });
        }
        this.child_number = this.number
        if (this.cart_list_item.length !== 0) {
          this.cart_list_item.forEach(element => {
            if (this.selectname == element.item_id) {
              this.child_number += element.num
              element.sub.forEach(sub_item => {
                const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                if (existingItem) {
                  // 如果存在，则将数量相加
                  existingItem.num += sub_item.num;
                }

                const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                if (free_existingItem) {
                  // 如果存在，则将数量相加
                  free_existingItem.num += sub_item.num;
                }
              });
            }
          });
        }
        this.parm = this.parm.concat(this.free_parm);
        this.free_parm = [];
        this.$store.dispatch('cart/add', {
          action: 'UPDATE',
          itemid: this.selectname,
          number: this.child_number,
          type: 'NOR',
          param: this.parm,
        }).then((e) => {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          if (e.result) {
            Toast.fire({
              icon: 'success',
              title: '成功加入購物車'
            })
            this.$router.push({
              path: `/cart`
            }).catch(err => { });
          } else {
            Toast.fire({
              icon: 'error',
              title: `${e.message}`
            })
          }
        });
        if (this.oig_id !== '') {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.oig_id));
                  myModal2.hide();
                } else {
                  const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.F_oig_id));
                  myModal2.hide();

                }
        // const myModal2 = this.$bootstrap.Modal.getInstance(document.getElementById('m' + this.F_oig_id));
        // myModal2.hide();
        // 選擇頁面上所有的.modal-backdrop元素
        const elements = document.querySelectorAll('.modal-backdrop');
        // 遍歷這些元素並移除
        elements.forEach(el => el.parentNode.removeChild(el));
      }
    },
    increment(index) {
      if (this.totalSum < this.child_num) {
        this.child_list[index].display_num++;
      }
    },
    validateInput(index) {
      // 确保当前输入是一个有效数字
      this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

      // 计算所有 display_num 的总和
      let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

      // 如果总和超过 child_num，则减少当前输入的值
      if (total > this.child_num) {
        let excess = total - this.child_num;
        this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
      }
    },
    decrement(index) {
      if (this.child_list[index].display_num > 0) {
        this.child_list[index].display_num--;
      }
    },
    increment_free(index) {
      if (this.totalSum_free < this.free_num) {
        this.free[index].display_num++;
      }
    },
    validateInput_free(index) {
      // 确保当前输入是一个有效数字
      this.free[index].display_num = Math.max(0, parseInt(this.free[index].display_num) || 0);

      // 计算所有 display_num 的总和
      let total = this.free.reduce((sum, item) => sum + item.display_num, 0);

      // 如果总和超过 child_num，则减少当前输入的值
      if (total > this.child_num) {
        let excess = total - this.child_num;
        this.free[index].display_num = Math.max(0, this.free[index].display_num - excess);
      }
    },
    decrement_free(index) {
      if (this.free[index].display_num > 0) {
        this.free[index].display_num--;
      }
    },
  },
  created() {
  },
  mounted() {
    // console.log(123);
    // console.log(this.oig_id);
    if (this.oig_id !== '') {

      const myModalEl = document.getElementById('m' + this.oig_id);
      if (myModalEl !== null) {

        myModalEl.addEventListener('hidden.bs.modal', event => {
          this.selectname = 0;
          for (let index = 0; index < $('.modalgo').length; index++) {
            $('.modalgo')[index].ariaLabel = null;
            $('.modalgo')[index].dataset.bsDismiss = null;
          }
        })
      }
    } else {
      const myModalEl = document.getElementById('m' + this.value.oig_id);
      if (myModalEl !== null) {

        myModalEl.addEventListener('hidden.bs.modal', event => {
          this.selectname = 0;
          for (let index = 0; index < $('.modalgo').length; index++) {
            $('.modalgo')[index].ariaLabel = null;
            $('.modalgo')[index].dataset.bsDismiss = null;
          }
        })
      }

    }
    // const myModalEl2 = document.getElementById('exampleModal2')
    // if (myModalEl !== null) {

    //   myModalEl.addEventListener('hidden.bs.modal', event => {
    //     this.selectname = 0;
    //     for (let index = 0; index < $('.modalgo').length; index++) {
    //       $('.modalgo')[index].ariaLabel = null;
    //       $('.modalgo')[index].dataset.bsDismiss = null;
    //     }
    //   })
    // }
    // if (myModalEl2 !== null) {
    //   myModalEl2.addEventListener('show.bs.modal', event => {
    //     console.log(2);
    //     console.log(this.item, '打开时');
    //   })
    // }
  },
}
</script>
<style lang='scss' scoped src="./shop.scss"></style>